import { render, staticRenderFns } from "./filterBox.vue?vue&type=template&id=63ef9b4b&scoped=true"
import script from "./filterBox.vue?vue&type=script&lang=js"
export * from "./filterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef9b4b",
  null
  
)

export default component.exports